// extracted by extract-css-chunks-webpack-plugin
module.exports = {"baseIcon":"LcZsZzymPRsx"};